module.exports = __webpack_public_path__ + "static/media/cgreen-cross.76576b9d.svg";